<template>
  <TransitionGroup
    name="toast-group"
    tag="div"
    appear
    :enter-active-class="$style['toast-group-enter']"
    :leave-to-class="$style['toast-group-leave-to']"
    :class="$style['toast-group']">
    <LazyToast
      v-for="toast in items"
      :id="toast.id"
      :key="toast.id"
      :impact="toast.impact"
      :class="$style['toast']"
      :icon="toast.icon"
      :type="toast.type">
      <span v-html="toast.message" />
      <template
        v-if="toast.secondaryAction"
        #secondary-action>
        <btn
          :to="toast.secondaryAction.to"
          color="white"
          @click="hideToast(toast.id)">
          {{ toast.secondaryAction.text }}
        </btn>
      </template>
    </LazyToast>
  </TransitionGroup>
</template>
<script setup>
const { hideToast, items } = useToast()
</script>
<style lang="scss" module>
.toast-group {
  display: flex;
  flex-direction: column;
  position: fixed;
  padding: $spacing;
  top: max(#{$spacing}, env(safe-area-inset-top));
  left: 50%;
  z-index: z-index(toast);
  width: $breakpoint-mobile;
  transform: translateX(-50%);
  max-width: 100%;

  .toast {
    transition: all $transition-time-slowest $transition-ease-in;
    margin-bottom: $spacing * 0.5;
  }
}

.toast-group-active,
.toast-group-enter,
.toast-group-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
</style>
